import type { FormikProps } from 'formik';
import type { List } from 'immutable';
import type { DateTime } from 'luxon';

import type { scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';
import type { RecurrenceType } from 'app-components/flux/scheduled-transactions/customFrequencyTypes';
import type { tagsTypes } from 'app-components/flux/tags';
import type { transactionsTypes } from 'app-components/flux/transactions';

// import type { Im2JS } from 'types/shared';

type ValueOf<T> = T[keyof T];

export const matchCriteriaOptions = Object.freeze({
  AUTO_MATCH: 'Auto Match',
  ANY_AMOUNT: 'Any Amount',
  EXACT_AMOUNT: 'Exact Amount',
  LIMITED_RANGE: 'Limited Range',
});

export type MatchOptions = ValueOf<typeof matchCriteriaOptions>;

export interface FormikScheduledTxn
  extends Omit<scheduledTransactionsTypes.ScheduledTransactionType, 'dueOn' | 'transaction'> {
  dueOn: DateTime<true>;

  transaction: Omit<transactionsTypes.TransactionProps, 'tags' | 'accountId'> & {
    tags?: List<tagsTypes.TagProps>;
    excludeF2SDest?: boolean;
    excludeReportsDest?: boolean;
    accountId: string;
  };
  virtualFrequency: string;
  virtualEndOn: DateTime<boolean> | null;
  virtualRecurrence: RecurrenceType;
  matchCriteria: MatchOptions;
}

export type STFormikProps = FormikProps<FormikScheduledTxn>;
